import { NavLink } from 'react-router-dom'
import { Layers, FileText, Boxes, LayoutDashboard, List } from 'lucide-react'

/**
 * Onglets de navigation hauts du builder. Partagé entre `BuilderHome`
 * (Pages) et `BuilderTypesHome` / `BuilderTypeShell` (Types de contenu).
 *
 * Style discret façon "underline tab" — pas de fond, juste un trait bas
 * qui suit l'onglet actif.
 */
export const BuilderNavTabs = () => (
  <nav className="flex items-center gap-6 px-6 -mb-px">
    <Tab to="/builder" icon={FileText} label="Pages" />
    <Tab to="/builder/contents" icon={List} label="Contenus" />
    <Tab to="/builder/dashboards" icon={LayoutDashboard} label="Tableaux de bord" />
    <Tab to="/builder/types" icon={Boxes} label="Types de contenu" />
  </nav>
)

/**
 * En-tête sticky commun (logo Page Builder + onglets) — affiché en haut de
 * `BuilderHome`, `BuilderTypesHome`, `BuilderTypeShell` pour cohérence.
 */
export const BuilderTopHeader = ({ rightSlot }) => (
  <header className="sticky top-0 z-30 bg-white border-b border-gray-200 shadow-sm">
    <div className="px-6 py-3 flex items-center justify-between">
      <div className="flex items-center gap-2">
        <Layers size={16} className="text-teal-700" />
        <span className="text-xs font-bold text-gray-400 uppercase tracking-widest">
          Page Builder
        </span>
      </div>
      {rightSlot}
    </div>
    <BuilderNavTabs />
  </header>
)

const Tab = ({ to, icon, label }) => {
  // `varsIgnorePattern: '^[A-Z_]'` covers locals — destructuring-rename on
  // props arguments isn't covered, so we rebind to a local.
  const IconComp = icon
  return (
    <NavLink
      to={to}
      end={to === '/builder'}
      className={({ isActive }) =>
        `flex items-center gap-1.5 pb-2 pt-1 border-b-2 text-sm transition-colors ${
          isActive
            ? 'border-teal-600 text-teal-700 font-medium'
            : 'border-transparent text-gray-500 hover:text-gray-800'
        }`
      }
    >
      <IconComp size={14} />
      {label}
    </NavLink>
  )
}
